module.exports = __webpack_public_path__ + "img/low-liquidity.e0ba16e5.svg";